module.exports = __webpack_public_path__ + "img/red_footer - 副本.e76b66f8.png";